<!-- <div class="container"> -->
<div class="row mx-0 mt-2 mb-5 py-3 bg-light" *ngIf="!drid">

  <div class="col-sm-6">
    <button class="btn btn-info" (click)="addApt()">Personal Hours</button>
  </div>
  <div class="col-sm-6 col-6 mt-1 mt-md-0 text-right">
    <button class="btn btn-info" (click)="openTimeModal()">Update default working hours</button>
  </div>

  <div class="col-sm-12 text-center">
    <span id="boot-icon" class="bi bi-dot"
      style="font-size: 76px; -webkit-text-stroke-width: 0.6px; opacity: 1; color: #1e90ff;">.</span>Inperson
    Consultation
    <span id="boot-icon" class="bi bi-dot"
      style="font-size: 76px; -webkit-text-stroke-width: 0.6px; opacity: 1; color: #e8720f;">.</span>Online - Video
    Consultation
    <span id="boot-icon" class="bi bi-dot"
      style="font-size: 76px; -webkit-text-stroke-width: 0.6px; opacity: 1; color: #e3bc08;">.</span>Online - Audio
    Consultation
    <span id="boot-icon" class="bi bi-dot"
      style="font-size: 76px; -webkit-text-stroke-width: 0.6px; opacity: 1; color: #ad2121;">.</span>Blocked by
    Physician
  </div>

</div>

<div class="row bg-white py-4 ml-0" [ngClass]="{'p-4 scrollModal': drid}">
  <div class="col-lg-12">

    <div class="row text-center calendar-navigation">
      <div class="col-md-4">
        <div class="btn-group">
          <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()" [excludeDays]="excludeDays">
            Previous
          </div>
          <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
            Today
          </div>
          <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()" [excludeDays]="excludeDays">
            Next
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en':weekStartsOn:excludeDays }}</h3>
      </div>
      <div class="col-md-4">
        <div class="btn-group">
          <div class="btn btn-primary" (click)="setView(CalendarView.Month)"
            [class.active]="view === CalendarView.Month">
            Month
          </div>
          <div class="btn btn-primary" (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">
            Week
          </div>
          <div class="btn btn-primary" (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">
            Day
          </div>
        </div>
      </div>
    </div>
    <br />
    <div *ngIf="events | async; let events">
      <div [ngSwitch]="view">
        <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
          [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"[weekendDays]="excludeDays" 
          class="monthview">
        </mwl-calendar-month-view>
        <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)" (beforeViewRender)="beforeWeekOrDayViewRender($event)"
          (hourSegmentClicked)="hourSegmentClicked($event?.date)" [ngClass]="{'modalView': drid}"
          [excludeDays]="excludeDays" [hourSegments]="3">
        </mwl-calendar-week-view>
        <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="events"
          [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)" (beforeViewRender)="beforeWeekOrDayViewRender($event)"
          (hourSegmentClicked)="hourSegmentClicked($event?.date)"
          [ngClass]="{'modalView': drid, 'not-working': !dayStartHour && !dayEndHour}" [dayStartHour]="dayStartHour"
          [dayEndHour]="dayEndHour" [hourSegments]="3">
        </mwl-calendar-day-view>
      </div>
    </div>

  </div>
</div>
<div class="row bg-white ml-0 border" *ngIf="drid">
  <div class="col-lg-12 py-2 text-right">
    <!-- //OK button not needed -->
    <!-- <button type="button" ngbAutofocus class="btn btn-primary mr-3" (click)="timeSlotSelected()"
        [disabled]="!emitSelectedDayViewDate">Ok</button> -->
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalClicked()">Cancel</button>
  </div>
</div>
<!-- All Modals start here -->

<ng-template #confirmationModal let-modal>
  <div class="modal-header bg-primary rounded-0">
    <h5 class="modal-title text-white" id="modal-basic-title">Delete Appointment</h5>
  </div>

  <div class="modal-body">
    <p>Are you sure you want to delete this appointment?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Ok</button>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Discard</button>
  </div>
</ng-template>

<ng-template #modalContent let-close="close">
  <div class="modal-header">
    <h5 class="modal-title">Event action occurred</h5>
    <button type="button" class="close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      Action:
      <pre>{{ modalData?.action }}</pre>
    </div>
    <div>
      Event:
      <pre>{{ modalData?.event | json }}</pre>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      OK
    </button>
  </div>
</ng-template>



<!-- Start Appointment modal -->
<ng-template #appointmentModal let-modal>
  <!-- Modal content -->
  <div class="modal-header bg-primary rounded-0">
    <h5 class="modal-title text-white" id="modal-basic-title">
      {{ this.modalData?.action === 'edit'? 'Edit' : 'Add an' }} appointment</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12">
        <p class="text-success font-weight-bold">{{modalData?.schedule_stat}}</p>
      </div>
    </div>
    <div class="row"
      *ngIf="modalData?.action === 'edit' && (modalData?.event?.meta?.patid || modalData?.event?.meta?.patname)">
      <div class="col-sm-12 mb-3">
        Patient: {{modalData.event.meta.patname}} - {{modalData.event.meta.patid}}
      </div>
    </div>
    <form class="mol-form" [formGroup]="scheduleAppointmentForm">

      <div class="row mb-3">
        <div class="col-lg-12">
          <input type="text" name="aptname" class="form-control" placeholder="Add a Title" formControlName="aptname"
            [ngClass]="{ 'is-invalid': scheduleAppointmentForm.controls.aptname.errors }" required>
          <div *ngIf="scheduleAppointmentForm.get('aptname').hasError('required')" class="invalid-feedback">
            Title is required
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <div class="input-group m-t-10">
            <div class="dp-hidden position-absolute">
              <div class="input-group">

                <!-- <input name="datepicker" ngbDatepicker #datepicker="ngbDatepicker"
                  (dateSelect)="onDateSelection($event)" [matDatepicker]="picker"> -->
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                  [autoClose]="'outside'" (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="2"
                  [dayTemplate]="t" outsideDays="hidden" [startDate]="startDate!" tabindex="-1"
                  style="border:1px solid white !important;" />
                <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                  </span>
                </ng-template>
              </div>
            </div>
            <div class="d-flex">

              <!-- <input class="form-control" placeholder="From Date" name="startDate" formControlName="startDate"
                id="startDate" [value]="formatter.format(startDate)" (dateSelect)="dateTimeChangeEvent($event)"
                (input)="startDate = validateInput(startDate, scheduleAppointmentForm['startDate'].value)" />

              <button class="btn btn-outline-secondary calendar rounded-0" (click)="datepicker.toggle()" type="button"
                style="line-height: 2.5;" id="startDateButton"><span class="fa fa-calendar"></span></button> -->
              <input class="form-control" placeholder="Start Date(DD/MM/YYYY)" name="startDate"
                formControlName="startDate" ngbDatepicker #sd="ngbDatepicker" (dateSelect)="dateTimeChangeEvent($event)"
                data-date-inline-picker="false" id="startDate" [minDate]="currentDate"
                [ngClass]="{ 'is-invalid': scheduleAppointmentForm.controls.startDate.errors }" />
              <div>
                <button class="btn btn-outline-secondary calendar rounded-0" (click)="sd.toggle()" type="button"
                  style="line-height: 2.5;" id="startDateButton">
                  <span class="fa fa-calendar"></span>
                </button>
              </div>
            </div>
            <div *ngIf="scheduleAppointmentForm.get('startDate').hasError('required')" class="invalid-feedback"> Start
              Date is required
            </div>
            <div
              *ngIf="!scheduleAppointmentForm.get('startDate').hasError('required') && scheduleAppointmentForm.get('startDate').hasError('ngbDate')"
              class="invalid-feedback"> Start Date is invalid
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-group m-t-10">
            <div class="d-flex">
              <!-- 
              <input class="form-control" placeholder="To Date" name="endDate" [value]="formatter.format(endDate)"
                (input)="endDate = validateInput(endDate, scheduleAppointmentForm['endDate'].value)" />
              <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="datepicker.toggle()"
                type="button"><span class="fa fa-calendar"></span></button> -->
              <input class="form-control" placeholder="End Date(DD/MM/YYYY)" name="endDate" formControlName="endDate"
                ngbDatepicker #ed="ngbDatepicker" [minDate]="scheduleAppointmentForm.value.startDate || currentDate"
                data-date-inline-picker="false" id="endDate" />
              <div>
                <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()" type="button"
                  style="line-height: 2.5;" id="endDateButton">
                  <span class="fa fa-calendar"></span>
                </button>
              </div>
            </div>
            <div *ngIf="scheduleAppointmentForm.get('endDate').hasError('ngbDate')" class="invalid-feedback"> End Date
              is invalid
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>Start Time</label>
          <ngb-timepicker formControlName="startTime" meridian=true (ngModelChange)="dateTimeChangeEvent($event)"
            [ngClass]="{ 'is-invalid': scheduleAppointmentForm.controls.startTime.errors }">
          </ngb-timepicker>
          <div *ngIf="scheduleAppointmentForm.get('startTime').hasError('required')" class="invalid-feedback"> Start
            Time is required
          </div>
          <div *ngIf="scheduleAppointmentForm.get('startTime').hasError('invalidStartTime')" class="invalid-feedback">
            Start Time is invalid
          </div>
        </div>
        <div class="col-md-6">
          <label>End Time</label>
          <ngb-timepicker formControlName="endTime" meridian=true (ngModelChange)="validateEndTime($event)"
            [ngClass]="{ 'is-invalid': scheduleAppointmentForm.controls.endTime.errors }">
          </ngb-timepicker>
          <div *ngIf="scheduleAppointmentForm.get('endTime').hasError('invalidEndTime')" class="invalid-feedback">
            End-Time should be greater than Start-Time
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="mt-3 form-check">
            <input type="checkbox" class="form-check-input" id="fullday" [(ngModel)]="fullday"
              [ngModelOptions]="{standalone: true}" (change)="fulldayClicked()">
            <label class="form-check-label" for="fullday"> &nbsp; Full Day</label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="bookAppointment()"
      [disabled]="scheduleAppointmentForm.invalid">
      {{ this.modalData?.action === 'edit'? 'Update' : 'Save' }}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Discard</button>
  </div>

</ng-template>

<!-- start and end time modal -->


<ng-template #timeModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Set Default Working Hours</h5>
  </div>
  <div class="modal-body p-4">
    <div>
      <div class="row justify-content-center" *ngFor="let day of workingHours">
        <div class="col-sm-2 my-auto">
          <div class="form-check d-flex">
            <label class="mt-5 mr-2 font-weight-bold" for="mon">{{day.dayName}}</label>
          </div>
        </div>
        <div class="col-sm-4">
          <label class="font-weight-bold">Start Time</label>
          <ngb-timepicker meridian=true [disabled]="day.Checked === true" [(ngModel)]="day.start_time"
            [ngModelOptions]="{standalone: true}">
          </ngb-timepicker>
        </div>
        <div class="col-sm-4">
          <label class="font-weight-bold">End Time</label>
          <ngb-timepicker meridian=true [disabled]="day.Checked === true" [(ngModel)]="day.end_time"
            [ngModelOptions]="{standalone: true}">
          </ngb-timepicker>
        </div>
        <!-- <div class="card m-b-30 border-0 form-check">
            <div class="row">
              <label class="mt-5 mr-2 font-weight-bold" for="dayoff">Day Off </label>
              <input type="checkbox" [value]="day.day" (change)="controlOnChange($event)" />
            </div>
          </div> -->
        <div class="col-sm-2 my-auto ">
          <!-- <div class="form-check d-flex"> -->
          <input class="mt-4 mr-2" type="checkbox" [value]="day.day" [checked]=day.Checked
            (change)="controlOnChange($event)" />
          <label class="font-weight-bold" for="dayoff">Day Off</label>
          <!-- </div> -->
        </div>
      </div>
      <br>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="setDefaultWorkingHours()"> Save </button>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Discard</button>
  </div>
</ng-template>

<!-- Approval modal -->
<ng-template #checkRequestModal let-modal>
  <div class="modal-body p-5">
    <div class="row">
      <div class="col-md-3">
        <img src="/assets/images/check-health.svg" class="">
      </div>
      <div class="col-md-9 mt-2">
        <div class="font-size-20 font-weight-400">Are you sure you want to accept appointment?</div>
        <p class="text-success mt-2 font-size-22 font-weight-500">This action cannot be undone!</p>
        <div class="mt-4 mb-4">
          <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4"
            (click)="modal.dismiss()">OOPS! NO. CANCEL</button>
          <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5" (click)="modal.close()">
            I AM SURE
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Reject/Delete modal -->
<ng-template #closeRequestModal let-modal>
  <div class="modal-body p-5">
    <div class="row">
      <div class="col-md-3">
        <img src="/assets/images/close-health-icon.png" class="">
      </div>
      <div class="col-md-9 mt-2">
        <div class="font-size-20 font-weight-400">Are you sure you want to decline appointment?</div>
        <p class="text-danger mt-2 font-size-22 font-weight-500">This action cannot be undone!</p>
        <div class="mt-4 mb-4">
          <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4"
            (click)="modal.dismiss()">OOPS! NO. CANCEL</button>
          <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5" (click)="modal.close()">
            I AM SURE
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>